var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0971 99.6758C63.4057 101.984 67.1486 101.984 69.4572 99.6758L109.115 60.0176C111.424 57.709 111.424 53.9661 109.115 51.6575C106.807 49.349 103.064 49.349 100.755 51.6575L65.2771 87.1357L50.578 72.4369C48.2694 70.1283 44.5265 70.1283 42.2179 72.4369C39.9094 74.7455 39.9094 78.4884 42.218 80.797L61.0971 99.6758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28882e-05 75.6667C2.28882e-05 117.456 33.8772 151.333 75.6667 151.333C117.456 151.333 151.333 117.456 151.333 75.6667C151.333 33.8772 117.456 -1.15235e-06 75.6667 -1.15235e-06C33.8772 -1.15235e-06 2.28882e-05 33.8772 2.28882e-05 75.6667ZM75.6667 139.51C40.4068 139.51 11.8229 110.927 11.8229 75.6667C11.8229 40.4068 40.4068 11.8229 75.6667 11.8229C110.927 11.8229 139.51 40.4068 139.51 75.6667C139.51 110.927 110.927 139.51 75.6667 139.51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck2);
export default __webpack_public_path__ + "static/media/success-check2.32c9c7e8df268c7012e9b3a57d00732a.svg";
export { ForwardRef as ReactComponent };